import styled, { createGlobalStyle } from 'styled-components'
import { color } from 'ui/themes/utils'

export const HostStyles = createGlobalStyle`
  :host, :root {
    /* Container variables */
    --minicart-button-size: 24px;
    --minicart-button-color: var(--color-primary-foreground, ${color('white')});
    --minicart-button-hover-color: var(--color-primary-foreground, ${color('white')});
    --minicart-button-hover-opacity: 0.6;
    --minicart-button-transition-duration: 0ms;

    /* Updated container variables */
    --minicart-button-transition-property: none;
    --minicart-button-transition-timing-function: linear;
    --minicart-button-transition-delay: 0ms;
    --minicart-button-outer-padding: 0px;
    --minicart-button-outer-border: none;
    --minicart-button-outer-hover-border: none;
    --minicart-button-outer-border-radius: 0px;
    --minicart-button-outer-background: transparent;
    --minicart-button-outer-background-hover: transparent;
    --minicart-button-outer-transition: none;

    /* Badge variables */
    --minicart-button-badge-color: var(--color-accent-foreground, ${color('white')});
    --minicart-button-border-radius: 12px;
    --minicart-button-padding: 4px;
    --minicart-button-font: var(--font-body, --minicart-font, Source Sans Pro, sans-serif);
    --minicart-button-font-size: 12px;
    --minicart-button-accent-color: var(--color-accent-background, ${color('branding')});
    --minicart-button-badge-size: 16px;
  }
`

export const Button = styled.div`
  position: relative;

  border: var(--minicart-button-outer-border);
  border-radius: var(--minicart-button-outer-border-radius);
  background: var(--minicart-button-outer-background);

  padding: var(--minicart-button-outer-padding);

  color: var(--minicart-button-color);

  cursor: pointer;

  > svg {
    height: var(--minicart-button-size);
    width: var(--minicart-button-size);
  }

  &:hover {
    color: var(--minicart-button-hover-color);

    border: var(--minicart-button-outer-hover-border);
    background: var(--minicart-button-outer-background-hover);

    > svg {
      opacity: var(--minicart-button-hover-opacity);
    }
  }

  transition-property: var(--minicart-button-transition-property);
  transition-duration: var(--minicart-button-transition-duration);
  transition-timing-function: var(--minicart-button-transition-timing-function);
  transition-delay: var(--minicart-button-transition-delay);
`

export const Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  bottom: 50%;
  left: 50%;

  min-height: var(--minicart-button-badge-size);
  min-width: var(--minicart-button-badge-size);
  aspect-ratio: 1/1;

  padding: var(--minicart-button-padding);

  border-radius: var(--minicart-button-border-radius);

  background: var(--minicart-button-accent-color);
  color: var(--minicart-button-badge-color);

  font-family: var(--minicart-button-font);
  font-size: var(--minicart-button-font-size);
  font-weight: 600;
  line-height: var(--minicart-button-badge-size);
  white-space: nowrap;
  text-wrap: nowrap;

  user-select: none;
`

Button.Badge = Badge

export default Button
